import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/ManagingReportsModel.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export default function ManageReportsModal({
  studyId,
  onClose,
  onReportAdded,
  onOpenReport,
}) {
  const [reports, setReports] = useState([]);
  const [reportName, setReportName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (studyId) {
      fetchReports();
    }
  }, [studyId]);

  const fetchReports = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/studies/${studyId}/reports/`
      );
      if (res.data.success) {
        setReports(res.data.reports);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleAddReport = async () => {
    if (!reportName.trim()) {
      setError("Report name is required.");
      return;
    }
    try {
      setLoading(true);
      setError("");
      const res = await axios.post(
        `${API_BASE_URL}/api/reports/create/`,
        {
          study_id: studyId,
          report_name: reportName,
          report_type: "WORD",
        }
      );

      if (res.data.success) {
        const report = res.data.report;

        setReports((prev) => [...prev, report]);
        setReportName("");

        onReportAdded?.(report);
        onClose();
      }
    } catch (err) {
      console.error(err);
      setError("Unable to create report.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="manage-report-overlay" onClick={onClose}>
      <div
        className="manage-report-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="manage-report-title">Manage Reports</h2>

        <div className="manage-report-list">
          {reports.length === 0 ? (
            <p className="no-reports-msg">No Reports Found</p>
          ) : (
            reports.map((report, index) => (
              <div key={report.id} className="manage-report-item">
                <span>
                  {index + 1}. {report.report_name}
                </span>

                <button
                  className="manage-report-open-btn"
                  onClick={() => onOpenReport(report)}
                >
                  Open
                </button>
              </div>
            ))
          )}
        </div>

        <div className="manage-report-divider" />

        <div className="manage-report-form">
          <h3>Create New Report</h3>

          <input
            type="text"
            value={reportName}
            placeholder="Report Name"
            className="manage-report-input"
            onChange={(e) => setReportName(e.target.value)}
          />

          {error && (
            <p className="manage-report-error">
              {error}
            </p>
          )}
        </div>

        <div className="manage-report-footer">
          <button
            className="manage-report-cancel"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="manage-report-submit"
            onClick={handleAddReport}
            disabled={loading}
          >
            {loading ? "Creating..." : "Create Report"}
          </button>
        </div>
      </div>
    </div>
  );
}